import type { IconProps } from './index';
import type { ReactElement } from 'react';

import { Svg } from './styles';
import { colors } from '../styles';

export const InfoCircleOutline = ({
  color = colors.BLACK,
  hoverColor,
}: IconProps): ReactElement => (
  <Svg
    version="1.1"
    baseProfile="tiny"
    id="Layer_2"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    overflow="inherit"
    viewBox="0 0 16 16"
    width="100%"
    height="100%"
    $hoverColor={hoverColor}
  >
    <g fill={color}>
      <path d="M8.083 4.667h1.333V6H8.083V4.667Zm0 2.666h1.333v4H8.083v-4Zm.667-6A6.67 6.67 0 0 0 2.083 8a6.67 6.67 0 0 0 6.667 6.667A6.67 6.67 0 0 0 15.416 8 6.67 6.67 0 0 0 8.75 1.333Zm0 12A5.34 5.34 0 0 1 3.416 8 5.34 5.34 0 0 1 8.75 2.667 5.34 5.34 0 0 1 14.083 8a5.34 5.34 0 0 1-5.333 5.333Z" />
    </g>
  </Svg>
);
